export default "__VITE_ASSET__a1191912__"